import { render, staticRenderFns } from "./ChordsInfoModal.vue?vue&type=template&id=14337a38"
import script from "./ChordsInfoModal.vue?vue&type=script&lang=js"
export * from "./ChordsInfoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports